import axiosInstance from '../../../../config/axiosInstance';
const ClientApiService = {
    async GetAll() {
        try {
           const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetAllClientApi?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
               
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async Delete(ID) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteClientApi?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default ClientApiService;